import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalizeSnackbarComponent } from './localize-snackbar/localize-snackbar.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [LocalizeSnackbarComponent],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports: [LocalizeSnackbarComponent],
})
export class SnackbarsModule {}
